/**
 * 首页自动导航组件
 * 当用户访问根路径时，自动导航到其有权限的第一个菜单页面
 */

import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

const AutoMenuNavigator: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isNavigating, setIsNavigating] = React.useState(false);

  useEffect(() => {
    // 只在根路径下执行自动导航
    if (location.pathname !== '/') {
      return;
    }

    // 检查是否已经有第一个菜单路径
    const firstMenuPath = localStorage.getItem('firstUserMenuPath');

    if (firstMenuPath) {
      // eslint-disable-next-line no-console
      console.log('[AutoMenuNavigator] Navigating to first user menu:', firstMenuPath);
      setIsNavigating(true);
      navigate(firstMenuPath, { replace: true });
    } else {
      // 如果还没有，等待一下再检查（菜单可能还在加载）
      const timer = setTimeout(() => {
        const retryPath = localStorage.getItem('firstUserMenuPath');
        if (retryPath) {
          // eslint-disable-next-line no-console
          console.log('[AutoMenuNavigator] Navigating to first user menu (retry):', retryPath);
          setIsNavigating(true);
          navigate(retryPath, { replace: true });
        }
      }, 1000); // 等待 1 秒

      return () => clearTimeout(timer);
    }
  }, [location.pathname, navigate]);

  if (isNavigating) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return null;
};

export default AutoMenuNavigator;
